<div mat-dialog-content>
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <h4>Project Gallery</h4>
            <div class="area">
                <input type="file" (change)="onGalleryImageChange($event)" multiple accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" />
                <label for="gallery">
                    <img src="assets/upload.png"><br>Drag and drop files<br>OR<br>
                    <div class="button-inside">Browse</div>
                </label>
                <p *ngIf="showError" class="error">Image size cannot exceed 2MB.</p>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <h4>Preview Images</h4>
            <div class="area preview-image row m-1">
                <div class="delete-holder col-sm-4" *ngFor="let image of galleryImagesPhotoPaths">
                    <div class="minus" (click)="removeFromGallery(image.name)">
                        <mat-icon>remove</mat-icon>
                    </div>
                    <img class="gallery-image" [src]="image.imagePath" />
                </div>
            </div>
        </div>
    </div>  
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-button (click)="savePropertyBasicInfo()" cdkFocusInitial>Save</button>
</div>